
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.25 3.5a1 1 0 00-1 1v1.25h-2A1.75 1.75 0 00.5 7.5V9a4 4 0 004 4h.164a7.741 7.741 0 001.877 3.001A7.75 7.75 0 0011 18.185V20H9a1 1 0 100 2h6a1 1 0 100-2h-2v-1.814c2.956-.386 5.366-2.454 6.315-5.186h.185a4 4 0 004-4V7.5a1.75 1.75 0 00-1.75-1.75h-2V4.5a1 1 0 00-1-1H5.25zm12.5 2H6.25v5c0 .373.036.744.108 1.108a.996.996 0 01.078.344 5.748 5.748 0 005.546 4.298h.062c2.668-.02 4.902-1.896 5.53-4.402a.992.992 0 01.037-.156c.09-.411.139-.838.139-1.276V5.5zm1.98 5.487c.013-.189.02-.38.02-.571V7.75h1.75V9a2 2 0 01-1.77 1.987zm-15.465 0a7.76 7.76 0 01-.015-.487V7.75H2.5V9a2 2 0 001.765 1.986z","fill":"#F0F4FA"}})])
          )
        }
      }
    